import { useMemo } from 'react';
import FilterPlate from '..';
import { FILTER_CLAUSE } from '../constants';
import { useFilter } from 'src/hooks/filters/useFilter';
import PropTypes from 'prop-types';

const FilterPlateCBoolean = (props) => {
	const {
		initialSelected,
		operator,
		onSubmit,
		yesLabel = 'Да',
		noLabel = 'Нет',
		yesValue = true,
		noValue = false,
		...rest
	} = props;

	const options = useMemo(
		() => [
			{ label: yesLabel, value: FILTER_CLAUSE.yes, boolValue: yesValue },
			{ label: noLabel, value: FILTER_CLAUSE.no, boolValue: noValue },
		],
		[yesLabel, noLabel, yesValue, noValue],
	);

	const handleSubmit = useMemo(() => {
		if (!onSubmit) return onSubmit;

		return (data) => {
			const boolValue =
				data.option?.boolValue !== undefined
					? data.option.boolValue
					: data.value;

			onSubmit({
				...data,
				value: boolValue,
			});
		};
	}, [onSubmit]);

	const { handleOptionChange, handleSubmit: submit, selectedOption } =
		useFilter(options, initialSelected, operator, handleSubmit, 'boolean');

	return (
		<FilterPlate
			typeSelector={{
				value: selectedOption,
				selectOnly: true,
				disableClearable: true,
				onChange: handleOptionChange,
				options,
			}}
			onSubmit={submit}
			{...rest}
		/>
	);
};

FilterPlateCBoolean.propTypes = {
	...FilterPlate.propTypes,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	operator: PropTypes.string,
	yesLabel: PropTypes.string,
	noLabel: PropTypes.string,
	yesValue: PropTypes.bool,
	noValue: PropTypes.bool,
};

export default FilterPlateCBoolean;
